import i18next from "i18next";
import * as React from "react";
import { I18nextProvider } from "react-i18next";

import { DEFAULT_LANGUAGE } from "../../../../company/settings/translations";
import global_es from "../../translations/es_ES/global.json";
import { ILink } from "../../types/thecookies";
import Debugger from "../Debugger/Debugger";
import GalleryEnhancer from "../Gallery/GalleryEnhancer";
import RotateScreenPlease from "../RotateScreenPlease/RotateScreenPlease";
import { Footer } from "./footer/footer";
import { LayoutContext } from "./LayoutContext";

interface Props {
  children: React.ReactNode;
  lang?: string;
  landingName?: string;
  legalLinks?: ILink[];
  navbarLinks?: ILink[];
}

const Layout: React.FC<Props> = (props: Props): React.ReactNode => {
  const lng = props.lang || DEFAULT_LANGUAGE;
  i18next.init({
    interpolation: { escapeValue: false },
    lng,
    resources: {
      es_es: {
        global: global_es,
      },
    },
  });

  // i18next.changeLanguage(lang).then(() => {});
  return (
    <LayoutContext.Provider value={{ ...props }}>
      <I18nextProvider i18n={i18next}>
        <div className={`l-table`}>
          {/*<Header />*/}
          {/*<Whatsapp />*/}
          {props.children}
          <Footer />
        </div>
        <RotateScreenPlease />
        <Debugger />
        <GalleryEnhancer />
      </I18nextProvider>
    </LayoutContext.Provider>
  );
};
export default Layout;
